import { handleAction } from 'redux-actions';
import { fetchWizardDataSuccess } from '../actions/actions';

import _ from 'lodash';

export const dataReducer = handleAction(
	fetchWizardDataSuccess,
	(state, { payload: data }) => {
		var recommendedPlugins = _.filter( data.plugins, (plugin) => {
			// Bail if the type matches, but the category doesn't.
			if ( plugin.is_recommended && plugin.category !== 'builder' ) {
				return plugin;
			}
		} )

		data.recommendedPlugins = recommendedPlugins

		return data;
	},
	{
		plugins: [],
		themes: [],
		recommendedPlugins: [],
	}
);
